<template>
  <div>
    <span v-if="!xs_only" class="text-no-wrap">
      <v-btn
        class="rounded-0 rounded-l-lg"
        depressed
        v-bind:color="language === 'en' ? 'major' : 'grey'"
        v-bind:outlined="language !== 'en'"
        v-on:click="changeLanguage('en')"
        dark
      >ENG</v-btn>
      <v-btn
        class="rounded-0 rounded-r-lg"
        depressed
        v-bind:color="language === 'th' ? 'major' : 'grey'"
        v-bind:outlined="language !== 'th'"
        v-on:click="changeLanguage('th')"
        dark
      >ไทย</v-btn>
    </span>
    <span v-if="xs_only">
      <v-btn
        fab
        small
        dark
        color="indigo"
        v-on:click="toggleLanguage()"
      >
        <span :class="language === 'en' ?'big-text':'small-text'">en</span>
        <span :class="language === 'th' ?'big-text':'small-text'">th</span>
      </v-btn>
    </span>
  </div>
</template>

<script>
export default {
  props: {},
  methods: {
    changeLanguage: function (lang) {
      if (lang == "en") {
        this.$root.$i18n.locale = "en";
        localStorage.setItem("language", "en");
      } else {
        this.$root.$i18n.locale = "th";
        localStorage.setItem("language", "th");
      }
    },
    toggleLanguage: function () {
      if (this.$root.$i18n.locale === "en") {
        this.$root.$i18n.locale = "th";
        localStorage.setItem("language", "th");
      } else {
        this.$root.$i18n.locale = "en";
        localStorage.setItem("language", "en");
      }
    },
  },
  computed: {
    language() {
      return this.$root.$i18n.locale;
    },
    xs_only() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  created: function () {
    if (localStorage.getItem("language") != null)
      this.$root.$i18n.locale = localStorage.getItem("language");
    else localStorage.setItem("language", this.$root.$i18n.locale);
  },
};
</script>

<style lang="scss" scoped>
.small-text {
  font-size: 8px;
}
.big-text {
  font-size: 13px;
}
</style>